const baseURL = process.env.REACT_APP_SERVER_URL;

export const conversationApi = {
  createConversation: async (user2_id: number) => {
    const result = await fetch(`${baseURL}/api/conversations/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
      body: JSON.stringify({ user2_id }),
    });

    return result.json();
  },

  getConversations: async (filter: string) => {
    const result = await fetch(`${baseURL}/api/conversations?unread=${filter}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });

    return result.json();
  },

  isUnreadMessages: async () => {
    const result = await fetch(`${baseURL}/api/chats/count`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });

    return result.json();
  },

  getChatByConversationId: async (id: any) => {
    const result = await fetch(`${baseURL}/api/conversations/chats?id=${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
    });

    return result.json();
  },
};
